import type { ActivationFlowAction, ActivationFlowModel } from './ActivationFlow.types'

const recoveryStatusFrom = (status: ActivationFlowModel['status']): ActivationFlowModel['status'] =>
  status === 'expired' || status === 'invalid' ? 'recovery' : status

export const reduceActivationRecoveryAction = (
  state: ActivationFlowModel,
  action: ActivationFlowAction,
): ActivationFlowModel | null => {
  switch (action.type) {
    case 'RECOVERY_EMAIL_CHANGED': {
      return {
        ...state,
        status: recoveryStatusFrom(state.status),
        recovery: {
          ...state.recovery,
          email: action.value,
          success: false,
          feedback: '',
          feedbackTone: 'error',
        },
      }
    }
    case 'RECOVERY_EMAIL_TOUCHED': {
      return {
        ...state,
        status: recoveryStatusFrom(state.status),
        recovery: {
          ...state.recovery,
          emailTouched: true,
        },
      }
    }
    case 'RECOVERY_SUBMIT_ATTEMPTED': {
      return {
        ...state,
        status: 'recovery',
        recovery: {
          ...state.recovery,
          submitAttempted: true,
          emailTouched: true,
          feedback: '',
          feedbackTone: 'error',
        },
      }
    }
    case 'RECOVERY_REQUEST_STARTED': {
      return {
        ...state,
        status: 'recovery',
        recovery: {
          ...state.recovery,
          submitState: 'pending',
          feedback: '',
          feedbackTone: 'error',
        },
      }
    }
    case 'RECOVERY_SUCCESS': {
      return {
        ...state,
        status: 'recovery',
        recovery: {
          ...state.recovery,
          submitState: 'idle',
          success: true,
          feedback: '',
          feedbackTone: 'error',
        },
      }
    }
    case 'RECOVERY_RATE_LIMIT': {
      return {
        ...state,
        status: 'recovery',
        recovery: {
          ...state.recovery,
          submitState: 'idle',
          success: false,
          feedback: action.message,
          feedbackTone: 'warning',
        },
      }
    }
    case 'RECOVERY_FAILURE': {
      return {
        ...state,
        status: 'recovery',
        recovery: {
          ...state.recovery,
          submitState: 'idle',
          success: false,
          feedback: action.message,
          feedbackTone: 'error',
        },
      }
    }
    default:
      return null
  }
}
